module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIxMyIgeT0iMTAiIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMCI+CjxwYXRoIGQ9Ik0yNi4xNzYyIDEyLjM1TDIzLjgyNjIgMTBMMTMuODI2MiAyMEwyMy44MjYyIDMwTDI2LjE3NjIgMjcuNjVMMTguNTQyOCAyMEwyNi4xNzYyIDEyLjM1WiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0iIzYwMzk3NSIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left-arrow.svg
// module id = oyEI
// module chunks = 37